import { DeepLinkButton } from "../DeepLinkButton/DeepLinkButton";

import style from "./PrivateCloudNotice.module.css";

export const PrivateCloudNotice = () => {
  return (
    <div className={style.container}>
      <div className={style.content}>
        <div className={style.title}>Viewing versions on web is disabled</div>
        <div className={style.description}>
          {"Your team\u2019s Private Cloud setup requires opening this project in the Shapr3D app."}
        </div>
        <div className={style.actions}>
          <DeepLinkButton variant="primary">Open in Shapr3D app...</DeepLinkButton>
        </div>
      </div>
    </div>
  );
};
